import { render, staticRenderFns } from "./ViqExpertUpsell.vue?vue&type=template&id=1bfa9579&scoped=true"
import script from "./ViqExpertUpsell.vue?vue&type=script&lang=js"
export * from "./ViqExpertUpsell.vue?vue&type=script&lang=js"
import style0 from "./ViqExpertUpsell.vue?vue&type=style&index=0&id=1bfa9579&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bfa9579",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1bfa9579')) {
      api.createRecord('1bfa9579', component.options)
    } else {
      api.reload('1bfa9579', component.options)
    }
    module.hot.accept("./ViqExpertUpsell.vue?vue&type=template&id=1bfa9579&scoped=true", function () {
      api.rerender('1bfa9579', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/viq/ViqExpertUpsell.vue"
export default component.exports